module.exports = __webpack_public_path__ + "img/HQ-ZU3-V1.d2f8f715.png";